import { UserSegment } from 'mise/src/types';

type GTMPropertyValue = string | string[] | number | UserSegment;
type GTMPropertyInputs = Record<string, GTMPropertyValue | null | undefined>;
type GTMPropertyOutputs = Record<string, GTMPropertyValue>;

export const cleanPropertiesForGTM = (properties: GTMPropertyInputs) => {
  const definedPropertiesForGTM = Object.entries(properties).reduce(
    (acc: Record<string, string | number | string[]>, [key, value]) => {
      if (value && value !== null && value !== undefined) {
        acc[key] = value;
      }
      return acc;
    },
    {} as GTMPropertyOutputs,
  );
  return definedPropertiesForGTM;
};
